import YFormUserRegister from './UserRegister';

export { YFormUserRegister };
export default YFormUserRegister;
